export const EMPTY = '*';
export const BLACK = '0';
export const WHITE = '1'; 